import { render, staticRenderFns } from "./ReleaseBundle.vue?vue&type=template&id=a42fc35c"
import script from "./ReleaseBundle.vue?vue&type=script&lang=js"
export * from "./ReleaseBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports